var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAcType = function SvgAcType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M6.719 8.397c1.259 0 2.279-.985 2.279-2.202 0-1.216-1.02-2.201-2.28-2.201-1.258 0-2.278.985-2.278 2.202 0 1.216 1.02 2.201 2.279 2.201ZM14.28 8.397c1.259 0 2.28-.985 2.28-2.202 0-1.216-1.021-2.201-2.28-2.201s-2.279.985-2.279 2.202c0 1.216 1.02 2.201 2.28 2.201ZM10.5 17.006c1.258 0 2.278-.986 2.278-2.202s-1.02-2.202-2.279-2.202-2.279.986-2.279 2.202 1.02 2.202 2.28 2.202ZM16.433 12.469a1.173 1.173 0 0 0 .043-1.698 1.274 1.274 0 0 0-1.758-.041 1.17 1.17 0 0 0-.042 1.698c.473.48 1.26.498 1.757.04ZM6.63 11.887c.165-.644-.243-1.295-.91-1.454-.666-.159-1.34.235-1.504.879s.243 1.294.91 1.453c.666.159 1.34-.234 1.504-.878Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "M19.603 9.859c0 4.509-3.241 8.26-7.505 9.02l-.136 1.424H9.038l-.136-1.424c-4.264-.76-7.505-4.511-7.505-9.02 0-5.06 4.076-9.162 9.103-9.162 5.026 0 9.102 4.103 9.102 9.162Z"
  })));
};
export default SvgAcType;